module.exports = __webpack_public_path__ + "img/Montenegro.b92efae6.svg";